import dayjs from 'dayjs';

export const isPaidMember = (m) => {
    console.log(`[[isPaidMember]] >>> params`, m);
    if (!m) {
        return false;
    }
    // paid date is valid, until 1st April the previous year, after the current year of paidDate
    const isMoreThan1stApril = dayjs().isAfter(dayjs().month(3).date(1));
    if(!m.paidDate) {
        return false;
    }
    const paidUserYear = dayjs(m.paidDate, 'D/M/YYYY').year();
    const currentPaidYear = isMoreThan1stApril ? dayjs().year() : dayjs().year() - 1;
    const isPaid = paidUserYear >= currentPaidYear;
    console.log(`[[isPaidMember]] result >>>`, { isMoreThan1stApril,paidUserYear, currentPaidYear, isPaid });
    return isPaid;
}
